import { getCountries } from 'country-provider';
const getCountriesSortedByNameExcludingRestricted = () => {
    const countries = getCountries(true);
    return countries.filter((country) => !country.restricted).sort((a, b) => a.name.localeCompare(b.name));
};
export default getCountriesSortedByNameExcludingRestricted;
